var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowBackBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.82822 10.8573H20.9235C21.5371 10.8573 22.0346 11.3689 22.0346 12.0001C22.0346 12.6313 21.5371 13.143 20.9235 13.143H5.82826L10.598 18.0491C11.032 18.4954 11.032 19.219 10.598 19.6653C10.1641 20.1116 9.46063 20.1116 9.02673 19.6653L2.37187 12.8202C2.31468 12.7631 2.26344 12.6997 2.21921 12.6311C2.20286 12.6058 2.18759 12.5799 2.17341 12.5536C2.08501 12.3896 2.03467 12.2009 2.03467 12.0001C2.03467 11.9935 2.03472 11.9868 2.03484 11.9802C2.03699 11.8508 2.06003 11.7268 2.10063 11.6113C2.15433 11.4582 2.24083 11.3146 2.36011 11.1919L9.02673 4.33474C9.46065 3.88842 10.1641 3.88842 10.598 4.33474C11.0319 4.78107 11.032 5.50464 10.598 5.95093L5.82822 10.8573Z",
    fill: "#171A21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBackBlack);
export default __webpack_public_path__ + "static/media/arrow-back-black.aa002ddf4fcdb0d824265b78d4d1d16c.svg";
export { ForwardRef as ReactComponent };